/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import { DynamicListAddButton, DynamicListWrapperProps } from '@finbeat/react-toolkit';
import { Trans } from 'react-i18next';
import { Table } from 'reactstrap';

const TwoColumnWrapper = ({
    children,
    col1Label,
    col2Label,
    ...props
}: DynamicListWrapperProps & {
    col1Label: string;
    col2Label: string;
}) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45">
                        <Trans i18nKey={col1Label} />
                    </th>
                    <th className="w-45">
                        <Trans i18nKey={col2Label} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

export default TwoColumnWrapper;
